import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { RmAssessment } from '../rm-assessment-models/rm-assessment.models';
import { environment } from '../../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class RmAssessmentService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async saveRmassessment(rmAssessment: RmAssessment) {

    const API_URL: string = environment.baseUrl + environment.apis.saveRmassessment;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: rmAssessment.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async viewRmassessment(viewid: number, status: string) {

    const API_URL: string = environment.baseUrl + environment.apis.viewRmassessment;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        onboarding_id: viewid,
        status: this.sessionStorageService.getCurrentUserRole() == 'DSU' || 'DSU Manager' ? ['Manager Review','Rectification'] : [status],
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getrectificationDocumentsCategorydropdown() {

    const API_URL: string = environment.baseUrl + environment.apis.documentsCategorydropdown;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        assigned_role: 'NewRep'
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getRectificationdocumentslist(viewid: number) {

    const API_URL: string = environment.baseUrl + environment.apis.viewdocumentslist;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        onboardingId: viewid,
        updatedByRole: this.sessionStorageService.getCurrentUserRole() == 'DSU' || 'DSU Manager' ? ['Director','Manager'] : [this.sessionStorageService.getCurrentUserRole()]
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

}
